// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wysT","rootMobile":"styles_rootMobile__Uala_"};